const PAYMENTS = {
  PAYMENTS: '/payments',
  SUBSCRIPTION: {
    SUBSCRIPTION: '/payments/subscription',
    RETRY: '/payments/subscription/retry'
  },
  CHECKOUT: {
    DEFAULT: '/payments',
    PLANS: '/payments/plans',
    CONFIGURE: '/payments/configure',
    PAYMENT: '/payments/payment',
    CONFIRMATION: '/payments/confirmation'
  }
} as const

export type CheckoutRoutesTypes =
  (typeof PAYMENTS.CHECKOUT)[keyof typeof PAYMENTS.CHECKOUT]

export default PAYMENTS
